import { RecipientLegalTextContent } from './RecipientLegalTextContent'

export const RecipientLegalText = () => (
  <div className='d-flex align-items-center flex-column'>
    <div className='mc-text--center col-11 col-md-8 col-lg-7'>
      <div className='d-block d-md-none'>
        <div className='mc-mt-9'>
          <RecipientLegalTextContent />
        </div>
      </div>
      <div className='d-none d-md-block'>
        <RecipientLegalTextContent />
      </div>
    </div>
  </div>
)
